export { ProductGallery, type ProductGalleryProps } from './ui/product-gallery';
